import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
  inputClassName?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, hint, error, className = '', inputClassName = '', id, ...props }, ref) => {
    const inputId = id || (label ? `input-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
    const stateClass = error ? 'ds-input--error' : props['aria-invalid'] ? 'ds-input--error' : '';

    return (
      <div className={`ds-field ${className}`}>
        {label ? (
          <label className="ds-field__label" htmlFor={inputId}>
            {label}
          </label>
        ) : null}
        <input
          ref={ref}
          id={inputId}
          className={`ds-input ${stateClass} ${inputClassName}`.trim()}
          aria-invalid={error ? true : props['aria-invalid']}
          {...props}
        />
        {error ? (
          <span className="ds-field__error" role="alert">
            {error}
          </span>
        ) : hint ? (
          <span className="ds-field__hint">{hint}</span>
        ) : null}
      </div>
    );
  }
);

Input.displayName = 'Input';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  hint?: string;
  error?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, hint, error, className = '', id, ...props }, ref) => {
    const inputId = id || (label ? `textarea-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);

    return (
      <div className={`ds-field ${className}`}>
        {label ? (
          <label className="ds-field__label" htmlFor={inputId}>
            {label}
          </label>
        ) : null}
        <textarea
          ref={ref}
          id={inputId}
          className={`ds-textarea ${error ? 'ds-input--error' : ''}`.trim()}
          aria-invalid={error ? true : undefined}
          {...props}
        />
        {error ? <span className="ds-field__error" role="alert">{error}</span> : hint ? <span className="ds-field__hint">{hint}</span> : null}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';

export default Input;
